import O1HD from "../../../../../engines/gameEngine";
import data_control from "../../../../../engines/libs/data_control";
import utilsModel from "../../../../../engines/libs/utilsModel";
import NormalGameManager from "../../../manager/NormalGameManager";
import oreSelectItem from "./oreSelectItem";
import { getOreV2Ary, getOreV2Map, getOreV2ObjAry, getOreV2SpecialAry, getOreV2SpecialMap, oreV2Interface, oreV2Map, oreV2SaveData, oreV2Type, refrenshItemPosAry, refrenshItemTypeAry } from "./oreV2Const";
import oreV2Item from "./oreV2Item";

const {ccclass, property} = cc._decorator;

@ccclass
export default class oreV2Select extends cc.Component {

    @property({type:cc.Node,displayName:"itemContent"})
    itemContent:cc.Node = null;

    @property({type:cc.Prefab,displayName:"itemPrefab"})
    itemPrefab:cc.Prefab = null;

    @property({type:cc.Prefab,displayName:"itemPrefabs"})
    iPrefabs:cc.Prefab[] = [];

    private oreV2_save_key:string = "ore-v2-save-key";
    
    private oreV2DaySaveKey:string = "ore-v2-data-save-key";

    private oreV2RefrenshCountSaveKey:string = "ore-v2-refrensh-count-save-key";

    private paitendSaveKey:string = "ore-v2-paitend0-save-key";

    isPantied:boolean = true;

    private oreV2Data:oreV2SaveData = {
        oreV2s: null,
        oreV2Type: oreV2Type.normal,
        orePosAry:null
    }

    private oreV2InitData:oreV2SaveData = {
        oreV2s: null,
        oreV2Type: oreV2Type.normal,
        orePosAry:null
    }

    start(){
        this.loadData();
    }

    checkDayIsVaild(){
        let isVaild = O1HD.getServices().localStorageSrv.getStorage(this.oreV2DaySaveKey) == data_control.getCurrDateDayString();
        if(!isVaild){
            O1HD.getServices().localStorageSrv.setStorage(this.oreV2DaySaveKey,data_control.getCurrDateDayString());
        }
        return isVaild;
    }

    loadRefrenshCount(){
        let countStr = O1HD.getServices().localStorageSrv.getStorage(this.oreV2RefrenshCountSaveKey) || "0";
        if(countStr == ""){
            countStr = "0";
        }
        this.refrenshCount = Number(countStr);
        if(isNaN(this.refrenshCount)){
            this.refrenshCount = 0;
        }
    }

    setRefrenshCount(count:number,isPlus:boolean = false){
        if(isPlus){
            this.refrenshCount += count;
        }else{
            this.refrenshCount = count;
        }
        O1HD.getServices().localStorageSrv.setStorage(this.oreV2RefrenshCountSaveKey,this.refrenshCount);
    }

    loadData(){
        let dataStr = O1HD.getServices().localStorageSrv.getStorage(this.oreV2_save_key) || JSON.stringify(this.oreV2InitData);
        if(dataStr == ""){
            dataStr = JSON.stringify(this.oreV2InitData);
        }

        this.oreV2Data = JSON.parse(dataStr);

        let patiendKey = O1HD.getServices().localStorageSrv.getStorage(this.paitendSaveKey) || "true";
        if(patiendKey == ""){
            patiendKey = "true";
        }

        this.isPantied = Boolean(this.isPantied);

        this.loadRefrenshCount();
        if(this.oreV2Data.oreV2s == null){
            this.oreV2Data.oreV2s = [];
            this.oreV2Data.orePosAry = [];
            this.refrenshItem();
        }
        if(!this.checkDayIsVaild()){
            // 日期不是合法的
            this.setRefrenshCount(0);
            this.refrenshItem();
        }
        this.loadItems();
    }

    spliceOneItem(itemID:number){
        let datas = this.oreV2Data.oreV2s;
        let posDatas = this.oreV2Data.orePosAry;
        // let index = datas.findIndex(id =>{
        //     return id == itemID;
        // });
        // if(index > -1){
            datas[itemID] = null;
            posDatas[itemID] = null;
        // }
        this.writeData();
    }

    writeData(){
        O1HD.getServices().localStorageSrv.setStorage(this.oreV2_save_key,JSON.stringify(this.oreV2Data));
    }

    refrenshCount:number = 0;

    //加载items
    loadItems(){
        let datas = this.oreV2Data.oreV2s;
        let posAry:cc.Vec2[] = this.oreV2Data.orePosAry;

        

        for(let i=0;i<datas.length;i++){
            let k = datas[i];
            if(k != null){
                let map:oreV2Map = null;
                // let type = this.oreV2Data.oreV2Type;
                // switch(type){
                //     case oreV2Type.normal:{
                        map = getOreV2Map();
                //         break;
                //     }
                //     case oreV2Type.special:{
                        // map = getOreV2SpecialMap();
                //         break;
                //     }
                // }
                let data = map[k];
                let node:cc.Node = cc.instantiate(this.iPrefabs[data.type]);
                let ns = node.getComponent(oreSelectItem);
                ns.bindData(data,this.onSelectOne.bind(this),i);
                node.setParent(this.itemContent);
                node.setPosition(posAry[i]);
                // console.log(posAry[i],"未知",type,datas[i],data)
            }
        }
    }

    setPatiend(isPainted:boolean){
        this.isPantied = isPainted;
        O1HD.getServices().localStorageSrv.setStorage(this.paitendSaveKey,this.isPantied);
    }

    onSelectOne(oneItem:cc.Node,dataIndex:number){
        let os = oneItem.getComponent(oreSelectItem);
        let data = os.oreV2Item;
        if(data){
            // 有数据 加载数据
            let needCoins:number = data.price;
            if(O1HD.getServices().userSrv.getCoins()<needCoins){
                NormalGameManager._instance.openBankPage();
                O1HD.getModules().uiControlModule.showMessageBox("钱不够");
                return;
            }
            O1HD.getServices().userSrv.setCoins(-needCoins,true);
            let item = cc.instantiate(this.itemPrefab);
            let is = item.getComponent(oreV2Item);
            is.bindData(data,this);
            item.setParent(O1HD.Canvas());
            this.spliceOneItem(dataIndex);
            console.log(dataIndex,"dataIndex");
            oneItem.destroy();
            oneItem.removeFromParent();
        }else{
            // 没有数据
            O1HD.getModules().uiControlModule.showMessageBox("未知错误,请重新进入该模块");
        }
    }

    //按钮刷新
    onBtnRefrensh(){
        utilsModel.loadAndShowVideoAdTrans(()=>{

            let childrens:cc.Node[] = this.itemContent.children;
            for(let i = childrens.length-1;i>=0;i--){
                childrens[i].destroy();
                childrens[i].removeFromParent();
            }
            this.setPatiend(false);
            this.scheduleOnce(()=>{
                this.setRefrenshCount(1,true);
                this.refrenshItem();
                this.loadItems();
            })
        },()=>{},null,"矿产看视频刷新");
    }

    refrenshItem(){
        let ary:oreV2Interface[] = [];
        let type:oreV2Type = oreV2Type.normal;

        let oreV2TypeAry = refrenshItemTypeAry.concat();
        let oreV2PosAry = refrenshItemPosAry.concat();

        let typeAry:number[] = []
        let v2Ary:cc.Vec2[] = [];
        if(this.refrenshCount < oreV2TypeAry.length){
            typeAry = oreV2TypeAry[this.refrenshCount];
            v2Ary = oreV2PosAry[this.refrenshCount];
        }else{
            let randIndex = Math.floor(Math.random() * oreV2TypeAry.length);
            typeAry = oreV2TypeAry[randIndex];
            v2Ary = oreV2PosAry[randIndex];
        }

        let oneAry:oreV2Interface[] = [];
        let twoAry:oreV2Interface[] = [];
        let threeAry:oreV2Interface[] = [];

        let itemAry:oreV2Interface[][] = [oneAry,twoAry,threeAry];

        ary = getOreV2Ary();
        type = oreV2Type.normal;

        for(let i=0;i<ary.length;i++){
            let item = ary[i];
            itemAry[item.type].push(item);
        }

        // if(this.refrenshCount >= 3){
        //     // 切换到特殊配置
        //     ary = getOreV2SpecialAry();
        //     type = oreV2Type.special;
        // }else{
            // 普通配置
            // ary = getOreV2Ary();
        // }
        this.oreV2Data.oreV2s = [];
        this.oreV2Data.orePosAry = [];
        for(let i = 0;i<typeAry.length;i++){
            let ttype = typeAry[i];
            let aId = data_control.getRandItemOfArray(itemAry[ttype]).id;
            this.oreV2Data.oreV2s[i] = aId;
            this.oreV2Data.orePosAry[i] = v2Ary[i].clone();
        }
        this.oreV2Data.oreV2Type = type;
        this.writeData();
    }

    onBtnBack(){
        this.node.destroy();
        this.node.removeFromParent();
    }

}
